import { Dayjs } from 'dayjs';
import { ReportType } from './Integrations';

export const FREQUENCY_NONE = 'None';
export const FREQUENCY_DAILY = 'Daily';
export const FREQUENCY_WEEKLY = 'Weekly';
export const FREQUENCY_BI_WEEKLY = 'Bi-Weekly';
export const FREQUENCY_MONTHLY = 'Monthly';
export type ScheduledReportMatchBy = 'name' | 'envelope_number';
export type DonorMatchByType = ScheduledReportMatchBy;

export const SCHEDULED_REPORT_FREQUENCIES = [
    FREQUENCY_NONE,
    FREQUENCY_DAILY,
    FREQUENCY_WEEKLY,
    FREQUENCY_BI_WEEKLY,
    FREQUENCY_MONTHLY,
] as const;

export type ScheduledReportFrequency =
    (typeof SCHEDULED_REPORT_FREQUENCIES)[number];

export const MONDAY = 'Monday' as const;
export const TUESDAY = 'Tuesday' as const;
export const WEDNESDAY = 'Wednesday' as const;
export const THURSDAY = 'Thursday' as const;
export const FRIDAY = 'Friday' as const;
export const SATURDAY = 'Saturday' as const;
export const SUNDAY = 'Sunday' as const;

export const WEEKDAYS = [
    MONDAY,
    TUESDAY,
    WEDNESDAY,
    THURSDAY,
    FRIDAY,
    SATURDAY,
    SUNDAY,
] as const;

export type Weekday = (typeof WEEKDAYS)[number];

export enum DATE_RANGE_TYPE {
    DONATION = 'Donation Date',
    BANK_DEPOSITS = 'Bank Deposit Date',
}

export type ScheduledReport = {
    createdAt?: Dayjs;
    dateRangeType: DATE_RANGE_TYPE;
    doneeId: number;
    frequency: ScheduledReportFrequency;
    id: number;
    lastRun?: Dayjs | null;
    matchBy: ScheduledReportMatchBy;
    name: string;
    nextRun?: Dayjs | null;
    receivesNotifications: boolean;
    reportType: ReportType;
    reportTypeVersion: string;
    scheduledDate: null | number;
    scheduledDay: null | Weekday;
    updatedAt?: Dayjs;
    updatedBy?: number;
};
